import React from 'react'
 
import { useMemo,useState,useEffect } from "react";
import { MAPS_API_KEY } from "../../Constants";
import { GoogleMap, InfoWindow, Marker,useLoadScript,MarkerClusterer } from "@react-google-maps/api";
import { FaMapMarker, FaPhone, FaUser } from 'react-icons/fa';

const ProjectMapViewer = (props) => {

    const { project } = (props.location && props.location.state) || {};
    const center = useMemo(() => ({ lat: 18.52043, lng: 73.856743 }), []);
    const [markers, setmarkers] = useState([]);
   

    const { isLoaded } = useLoadScript({
        googleMapsApiKey: MAPS_API_KEY  
      });
    
    const formatData=()=>{
        let records=[];
       
        project.forEach((bnf)=>{
            let pos={};
            try{
pos=JSON.parse(bnf.location);
           
           
          

        
        }catch(e){}
        let lat=pos?.latitude??0;
        if(!lat==0){
            records.push({
                id:bnf.beneficiary_inst_id,
                phone:bnf.telephone,
                name:bnf.name,
                district:bnf.district_name,
                village:bnf.village_name,
                region:bnf.region_name,
                camp:bnf.camp_name,
                position:{lat:pos?.latitude??0,lng:pos?.longitude??0}
            })
        }
       
        })

        setmarkers(records);
    }

    useEffect(() => {
        formatData();
        return () => {
    
        }
      }, [])
    const libraries = ["places"]
    const [selectedElement, setSelectedElement] = useState(null);
    // const [activeMarker, setActiveMarker] = useState(null);
    const [showInfoWindow, setInfoWindowFlag] = useState(true);
   


 
const [activeMarker, setActiveMarker] = useState(null);

const handleActiveMarker = (marker) => {
  if (marker === activeMarker) {
    return;
  }
  setActiveMarker(marker);
};

const handleOnLoad = (map) => {
  const bounds = new window.google.maps.LatLngBounds();
  
  markers.forEach(({ position }) => bounds.extend(position));
  map.fitBounds(bounds);
};
 
     let position =  {lat:4.8101400000000005 , lng: 45.17062166666666};
    const options = {
        imagePath:
          "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m" // so you must have m1.png, m2.png, m3.png, m4.png, m5.png and m6.png in that folder
      };
    return (
        <div>
            {/* {JSON.stringify(markers)} */}
       
        {isLoaded ?
        <GoogleMap
          onLoad={handleOnLoad}
          onClick={() => setActiveMarker(null)}
          mapContainerStyle={{ width: "98vw", height: "80vh" }}
          className="g_map"
        >
          
          <MarkerClusterer options={options} minimumClusterSize={2}>
        {(clusterer) => (
          <div>
           
          {markers?.map(({ id, name,camp,phone,region,district,village, position }) => 
            <Marker
              key={id}
              position={position}
                clusterer={clusterer}

              onClick={() => handleActiveMarker(id)}
            >
              {activeMarker === id ? (
                <InfoWindow onCloseClick={() => setActiveMarker(null)}>
                  <div>
                    <h4>Beneficiary Details</h4>
                     <FaUser></FaUser> Name : <b> {name} </b>  <br/>
                     <FaPhone></FaPhone> Phone : <b> {phone}  </b> <br/>
                     <FaMapMarker></FaMapMarker> Region: <b> {region} </b>  District: <b> {region} </b>  Village: <b> {village} </b>     Camp: <b> {camp} </b>      <br/>
                        </div>
                </InfoWindow>
              ) : null}
            </Marker>
          ) }  
          </div>)}
              </MarkerClusterer>

        </GoogleMap> : <h1>Loading..</h1>
}
        </div>

      );
 
 
  
 
}

export default ProjectMapViewer



 